module.exports = __webpack_public_path__ + "static/PRI_America_Abroad-5d6ff44bd5a21cecea18cab231574d33.png";